import { app } from '../../app.module'
app
  // Instagram投稿テーブルの平均値
  .directive('postInstagramTableAverage', () => {
    return {
      restrict: 'EA',
      template: require('./post-instagram-table-average.pug')(),
      controller: function ($scope) {
        $scope.$watch(
          () => {
            return $scope.postsDataAverage
          },
          () => {
            if ($scope.postsDataAverage !== undefined) {
              // いいねの平均
              $scope.likesAverage = $scope.postsDataAverage.likes / $scope.query.postsCount
              // コメントの平均
              $scope.commentsAverage = $scope.postsDataAverage.comments / $scope.query.postsCount
              // 反応数の平均
              $scope.engagementsAverage =
                $scope.postsDataAverage.engagements / $scope.query.postsCount
              // 反応率の平均
              $scope.engagementRateAverage =
                $scope.postsDataAverage.engagementRates / $scope.query.postsCount
            }
          }
        )
      },
    }
  })
